<template>
  <div id="conteiner">
    <v-row no-gutters>
      <div id="side_menu">
        <div id="logo"><a href="#"><img src="@/assets/logo.png" width="432" height="162"> </a></div>
        <FormLogin v-if="formLoginComp" @openRegister="formLoginComp = false" />
        <FormRegister v-if="!formLoginComp" @openLogin="formLoginComp = true" />
      </div>
      <div id="content">
        <iframe
          src="https://avraham.clickcall.co.il/background/display"
          frameborder="0"
          allowfullscreen
          style="width: 100% !important; height: 100% !important; border: none;"
        ></iframe>
      </div>
    </v-row>
  </div>
</template>

<script>
import FormLogin from '@/components/auth/FormLogin.vue'
import FormRegister from '@/components/auth/FormRegister.vue'
import Auth from '@/services/auth.service.js'

export default {
  components: {
    FormLogin,
    FormRegister
  },
  data: () => ({
    formLoginComp: true,
  }),
  mounted() {
    document.title = 'Login | clickcall'

    let auth = Auth.checkAuth();
    if (auth) {
      this.$router.replace({ name: "home" })
    }
  },
}
</script>

<style scoped>
#conteiner {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  height: 100vh;
}

#side_menu {
  background: linear-gradient(135deg, #0e3280 0%, #0a2357 100%) !important;
  width: 34%;
  float: right;
  height: 100vh;
  font-size: .8vw;
}

#content {
  width: 66%;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-color: #f7f7f7;
}

#logo {
  text-align: center;
  margin: 10% 0 0 0;
}

#logo img {
  width: 61%;
  margin-right: 4%;
  height: 100%;
}

@media only screen and (max-width: 998px) and (min-height: 600px) {
  #content {
    display: none !important;
  }

  #side_menu {
    width: 100%;
    font-size: 3vw;
  }
}

.notification {
  display: block;
  padding: 3% 13% 3% 5%;
  width: 76%;
  border-radius: .4vw;
  margin-bottom: 2vh;
}

/* Roboto font for English */
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
</style>